module.exports = __webpack_public_path__ + "media/images/icon-svg/checked-6ccf4fdbe6855843e7e86b9eb2fdfead.svg";